import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'
import { getCurrentDate } from '../../../utilities/dateTime.util'

export const relationshipsAndGuarantorsSchemas = [
  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_FIRST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_NAME'],
    errorMessage: {
      properties: {
        SET_FIRST_NAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_MIDDLE_INITIAL,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MIDDLE_INITIAL: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MIDDLE_INITIAL'],
    errorMessage: {
      properties: {
        SET_MIDDLE_INITIAL: 'Must be alphanumeric with max length of 1',
      },
    },
  },

  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_LAST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LAST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,60}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LAST_NAME'],
    errorMessage: {
      properties: {
        SET_LAST_NAME: 'Must be alphanumeric with max length of 60',
      },
    },
  },

  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_DOB,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DOB: {
        type: 'string',
        format: 'nemsis-dob',
      },
    },
    additionalProperties: false,
    required: ['SET_DOB'],
    errorMessage: {
      properties: {
        SET_DOB: 'Must be in the format: MM/DD/YYYY and not greater than ' + getCurrentDate(),
      },
    },
  },

  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_AGE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_AGE: {
        type: 'integer',
        minimum: 0,
        maximum: 120,
      },
    },
    additionalProperties: false,
    required: ['SET_AGE'],
  },

  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_SSN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SSN: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_SSN'],
    errorMessage: {
      properties: {
        SET_SSN: 'Must be in the format: NNN-NN-NNNN',
      },
    },
  },
  {
    inputKey: RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DRIVERS_LICENSE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,20}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DRIVERS_LICENSE'],
    errorMessage: {
      properties: {
        SET_DRIVERS_LICENSE: 'Must be alphanumeric with max length of 20',
      },
    },
  },
]
